import React from 'react';

const Text = () => (
    <article>
    <h3>Looking for a trainee</h3>
    <p>
      Invisible Hand is a newly founded artist and label consultancy.
      We are looking for a trainee in our Berlin office to assist in the day-to-day operations.
    </p>
      <h5>Tasks will include</h5>
      <p>
        <ul>
          <li>Managing manufacturing process</li>
          <li>Setting up releases for digital and physical distribution</li>
          <li>Coordinating and monitoring all information between management and artists</li>
          <li>Assist and support the managing director</li>
          <li>Managing workflow and efficiency</li>
          <li>Working closely together with the manager providing general support and effective management processes</li>
        </ul>
      </p>
      <h5>Essential skills needed</h5>
      <p>
        <ul>
        <li>Excellent communication skills</li>
        <li>High organizational and planning skills</li>
          <li>Keen and excellent accuracy and strong attention to detail</li>
          <li>Strong problem-solving and follow-up skills</li>
          <li>Proficiency with Mac O/S, Gmail & Google Docs/Drive/Calendar</li>
          <li>Knowledge about all social media platforms</li>
          <li>In-depth music knowledge, understanding and passion for all types of electronic music</li>
        </ul>
        </p>
      <h5>We offer</h5>
      <p>
        <ul>
          <li>A young and open-minded team in Berlin </li>
          <li>Diverse artists and labels  </li>
          <li>A creative international network  </li>
          <li>Flexible working times  </li>
          <li>Fun fun fun  </li>
        </ul>
      </p>
      <p>
        If interested, please <a href="mailto:contact@invisiblehand.agency" className="underlined-link">send</a> us a CV.
      </p>
</article>);

export default Text;
